import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  dataInRequest,
  deleteData,
  findData,
} from '~/store/modules/modulosCliente/actions';

import MyForm from './form';

function ModulosCliente() {
  const redux = useSelector((state) => state.modulosCliente);

  const header = useMemo(
    () => [
      {
        id: 'idmodulo',
        label: t('s.cadastro.usuario.idusuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodulo',
        label: t('s.configuracao.alarme.idmodulo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={dataInRequest}
      find={findData}
      remove={deleteData}
      form={MyForm}
      keys="idmodulo"
      detach="nomemodulo"
    />
  );
}

export default ModulosCliente;
